import React, { useState } from "react";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faTelegram } from "@fortawesome/free-brands-svg-icons";

function EnterYourName() {
  const [input, setInput] = useState("");
  const navigate = useNavigate();

  const submitHandler = () => {
    navigate(`/room/${input}`);
  };

  return (

    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <input
        style={{
          padding: "10px",
          borderRadius: "5px",
          border: "2px solid #ccc",
          outline: "none",
          fontSize: "16px",
          marginRight: "10px",
          width: "200px",
        }}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        type="text"
        placeholder="Enter Your Name.."
      />
      <button
        style={{
          padding: "10px 20px",
          borderRadius: "5px",
          border: "none",
          backgroundColor: "#007bff",
          color: "white",
          fontSize: "16px",
          cursor: "pointer",
        }}
        onClick={submitHandler}
      >
        Join
      </button>

        <h2 style={{marginTop:'5rem'}}>Jion Community For Katha Link Will <span style={{color:'blue'}}> Share</span> on this Community</h2>
      <div>
        <button className="whatsapp-button">
          <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
        </button>
        <button className="telegram-button">
          <FontAwesomeIcon icon={faTelegram} /> Telegram
        </button>
      </div>
    </div>
  );
}

export default EnterYourName;
